define('services/myservices/myservice-add-service.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('myServicesAddSer', ['$q', '$filter', 'ngDialog', 'OpenApp', 'auiDialog', 'opearteShaService', 'UserInfo',
        function ($q, $filter, ngDialog, OpenApp, auiDialog, opearteShaService, UserInfo) {

            /**
             * 修改产品信息
             * @param updateParams
             */
            function updateApp(updateParams) {
                var defer = $q.defer();
                OpenApp.updateApp(updateParams).then(function (updateData) {
                    if (updateData && updateData.prodSerialNo) {
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                }).catch(function (data) {
                    defer.reject();
                });
                return defer.promise;
            }

            /**
             * 修改指纹
             * @param Model
             */
            function updateOauthFingerPrint(Model) {
                var defer = $q.defer();
                var appInfo = Model.product.appInfo;
                // 1.更新指纹、回调地址
                if (Model.serviceItem == 8) {
                    defer.resolve();
                    return defer.promise;
                }

                var appIDTemp = appInfo.appID;
                var getAtrrs = {
                    request: {
                        appID: appIDTemp,
                        serviceItem: Model.serviceItem
                    }
                };
                var appAttrs = {};
                if (appInfo && appInfo.appAttrs) {
                    appAttrs = angular.fromJson(appInfo.appAttrs);
                }
                if (Model.selected.webAppUrl) {
                    appAttrs.webAppUrl = Model.selected.webAppUrl;
                }
                if (Model.selected.bundleId && Model.selected.prodType == 22) {
                    appAttrs.bundleId = Model.selected.bundleId;
                    appAttrs.testBundleId = Model.selected.testBundleId;
                    getAtrrs.request.bundleId = Model.selected.bundleId;
                    getAtrrs.request.testBundleId = Model.selected.testBundleId;

                }
                // 服务器应用、h5没有指纹
                if (appInfo.prodType != 22 && appInfo.prodType != 7 && !(appInfo.prodType == 19 && appInfo.freeInstallType == 2)) {
                    opearteShaService.opearteShaService(appAttrs, angular.copy(Model.selected));
                }
                //获取安全 URL
                if (Model.serviceItem == 32) {
                    if ((Model.accessModeType.length > 1 && Model.accessModeType[1].flag) || (appInfo.prodType == 19 && appInfo.freeInstallType == 2)) {
                        getseureUrl(appAttrs, Model);
                    } else {
                        delete appAttrs.secureUrlList;
                    }
                    if (Model.selected.callbackUrlList.length > 0) {
                        appAttrs.oauthRedirectUriExtra = Model.selected.callbackUrlList.slice(1);//去除第一个元素
                        appAttrs.oauthRedirectUriExtra = AUI.BaseJSUtil.deleteValueForArray(appAttrs.oauthRedirectUriExtra, '');
                        appAttrs.oauthRedirectUri = Model.selected.callbackUrlList[0];
                    } else {
                        appAttrs.oauthRedirectUriExtra = [];
                        appAttrs.oauthRedirectUri = "";
                    }


                }
                getAtrrs.request.appAttrs = JSON.stringify(appAttrs);
                OpenApp.updateAppAttrs(getAtrrs).then(function (getAtrrsData) {
                    if (getAtrrsData && getAtrrsData.prodSerialNo) {
                        // 发送消息给网关，异步处理。
                        opearteShaService.sendMsgToOpenGWapi(appIDTemp);
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                }).catch(function (data) {
                    defer.reject();
                });

                return defer.promise;
            }

            /**
             * 更新包名或应用访问地址（H5）
             * @param Model
             */
            function updatePackageName(Model) {
                var defer = $q.defer();
                var appInfo = Model.product.appInfo;
                var gOpenAppInfo = {appID: appInfo.appID};

                var updateParams;
                if (Model.selected.bundleId && Model.selected.prodType === '22') {
                    gOpenAppInfo.bundleId = Model.selected.bundleId;
                }
                if (Model.selected.testBundleId) {
                    gOpenAppInfo.testBundleId = Model.selected.testBundleId;
                }
                if ((appInfo.prodType == 19 && appInfo.freeInstallType == 2) || appInfo.prodType == 7 || appInfo.prodType == 22) { //服务器应用，H5没有包名
                    gOpenAppInfo.webAppUrl = Model.selected.webAppUrl;
                    //服务器应用，H5没有包名 并且帐号服务需要更新appICon
                    if (Model.serviceItem == 32) {
                        gOpenAppInfo.languages = [{
                            language: appInfo.defaultLang,
                            appName: appInfo.appName,// Model.appIcon ? Model.appIcon.substr(Model.appIcon.indexOf("/app/")) : ''
                            appIcon: Model.appIcon ? (sysParamCfg.switchConf.isAgcSupportIcon ? Model.appIcon : Model.appIcon.substr(Model.appIcon.indexOf("/app/"))) : ''
                        }];
                    }
                    //运动健康且是免安装/H5应用 需要增加是否支持服务器应用字段
                    if (Model.serviceItem == 43) {
                        if (appInfo.prodType == 19 && appInfo.freeInstallType == 2) {
                            gOpenAppInfo.webAppType = Model.supportServer ? '1,2' : '1';
                        }
                        if ((appInfo.prodType == 19 && appInfo.freeInstallType == 2) || appInfo.prodType == 7) {
                            gOpenAppInfo.webAppType = Model.supportServer ? '1,2' : '1';
                            gOpenAppInfo.contactInfo = angular.toJson({
                                email: Model.product.contactInfo.email ? Model.product.contactInfo.email : '',
                                devName: Model.product.contactInfo.devName ? Model.product.contactInfo.devName : '',
                                phoneNum: Model.product.contactInfo.phoneNum ? Model.product.contactInfo.phoneNum : '',
                                address: Model.product.contactInfo.address ? Model.product.contactInfo.address : '',
                                website: Model.product.contactInfo.website ? Model.product.contactInfo.website : '',
                                devType: UserInfo.get().userType
                            })
                        }

                    }
                    updateParams = {
                        request: {
                            appInfo: gOpenAppInfo,
                            serviceItem: Model.serviceItem
                        }
                    };
                } else {
                    if (!Model.selected.hasPackageName) {
                        gOpenAppInfo.packageName = Model.selected.packageName;
                        updateParams = {
                            request: {
                                appInfo: gOpenAppInfo,
                                serviceItem: Model.serviceItem
                            }
                        };
                    }
                }

                if (updateParams) {
                    updateApp(updateParams).then(function () {
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            function getseureUrl(appAttrs, Model) {
                appAttrs.secureUrlList = angular.copy(Model.secureUrlList);
            }

            return {
                updateApp: updateApp,
                updateOauthFingerPrint: updateOauthFingerPrint,
                updatePackageNameOrWebUrl: updatePackageName
            }

        }]);
});


